// The on-screen keyboard must shrink the app, never scroll it: a scrolled page pushes the
// conversation header (and the team strip) off the top while the composer has focus.
// Chrome on Android does this from the viewport meta (`interactive-widget=resizes-content`).
// Safari ignores that and pans the page instead, so the app's height follows the VISUAL viewport
// (the part the keyboard leaves) and any pan the browser applies is undone.

const APP_HEIGHT = '--app-height';

export function installKeyboardViewport(): void {
  const vv = window.visualViewport;
  if (!vv) return;
  const root = document.documentElement;
  const apply = () => {
    // Pinch-zoom also shrinks the visual viewport: only follow it at 1:1, or zooming would squash the app.
    if (Math.abs(vv.scale - 1) > 0.01) {
      root.style.removeProperty(APP_HEIGHT);
      return;
    }
    root.style.setProperty(APP_HEIGHT, `${Math.round(vv.height)}px`);
    if (window.scrollY !== 0 || root.scrollTop !== 0) window.scrollTo(0, 0);
  };
  vv.addEventListener('resize', apply);
  vv.addEventListener('scroll', apply);
  apply();
}
